import { render, staticRenderFns } from "./UmsUsers.vue?vue&type=template&id=128dda12&"
import script from "./UmsUsers.vue?vue&type=script&lang=js&"
export * from "./UmsUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports